import { Component } from 'react'
import Slider from 'beam/dist/Slider'
import { FormControl, FormLabel, FormHelperText } from 'beam/dist/Form'
import PropTypes from 'prop-types'
import fieldPropTypes from './FieldPropTypes'
import { withTranslation } from 'react-i18next'
import withStyles from 'beam/dist/styles'
import { get } from 'lodash'

const styles = theme => ({
  root: {
    display: 'inline-flex',
  },
  sliderFieldLabel: {
    marginBottom: theme.spacing(2),
  },
})

class FormSliderField extends Component {
  static propTypes = {
    ...fieldPropTypes,
    displayValueFn: PropTypes.func,
    showValue: PropTypes.bool,
  }

  static defaultProps = {
    showValue: false,
    displayValueFn: value => value,
  }

  //https://github.com/mui-org/material-ui/issues/11990
  handleChange = (event, value) => {
    const {
      form,
      field: { name },
    } = this.props
    form.setFieldValue(name, value)
    this.props.onChange && this.props.onChange(value)
  }

  render() {
    const {
      label,
      field,
      required,
      classes,
      sliderProps,
      field: { value },
      form: { errors, touched },
      showValue,
      displayValueFn,
    } = this.props

    return (
      <FormControl
        required={required}
        error={!!get(touched, field.name) && !!get(errors, field.name)}
        fullWidth={true}
        className={classes.root}
      >
        {label && <FormLabel className={classes.sliderFieldLabel}>{label}</FormLabel>}
        <Slider {...field} onChange={this.handleChange} {...sliderProps} />
        <FormHelperText required={required} error={!!get(touched, field.name) && !!get(errors, field.name)}>
          {showValue && displayValueFn(value)} {!!get(touched, field.name) && get(errors, field.name)}
        </FormHelperText>
      </FormControl>
    )
  }
}

export default withTranslation()(withStyles(styles)(FormSliderField))
